import BlockRegistry from '../../BlockRegistry';

const stripQuotes = (str) => {
    if (typeof str === 'string' && str.startsWith('"') && str.endsWith('"')) {
        return str.slice(1, -1);
    }
    return str;
};

export function registerGenericDevice() {
    
    BlockRegistry.register('genericDevice_setPinMode', (block, context) => {
        let pin = context.getInputValue(block, 'PIN') || context.getFieldValue(block, 'PIN');
        let mode = context.getInputValue(block, 'MODE') || context.getFieldValue(block, 'MODE');
        
        pin = stripQuotes(pin);
        mode = stripQuotes(mode);
        
        // Pushes to setup exactly once
        context.addSetup(`pinMode(${pin}, ${mode});`);
        return ''; // No loop code
    });

    BlockRegistry.register('genericDevice_digitalWrite', (block, context) => {
        let pin = context.getInputValue(block, 'PIN') || context.getFieldValue(block, 'PIN');
        let state = context.getInputValue(block, 'STATE') || context.getFieldValue(block, 'STATE');
        
        pin = stripQuotes(pin);
        state = stripQuotes(state);
        
        return `digitalWrite(${pin}, ${state})`;
    });

    BlockRegistry.register('genericDevice_digitalRead', (block, context) => {
        let pin = context.getInputValue(block, 'PIN') || context.getFieldValue(block, 'PIN');
        pin = stripQuotes(pin);
        return `digitalRead(${pin})`;
    });

    BlockRegistry.register('genericDevice_analogWrite', (block, context) => {
        let pin = context.getInputValue(block, 'PIN') || context.getFieldValue(block, 'PIN');
        let value = context.getInputValue(block, 'VALUE') || context.getFieldValue(block, 'VALUE');
        
        pin = stripQuotes(pin);
        value = stripQuotes(value);
        
        return `analogWrite(${pin}, ${value})`;
    });

    BlockRegistry.register('genericDevice_analogRead', (block, context) => {
        let pin = context.getInputValue(block, 'PIN') || context.getFieldValue(block, 'PIN');
        pin = stripQuotes(pin);
        return `analogRead(${pin})`;
    });

    BlockRegistry.register('genericDevice_waitUntil', (block, context) => {
        let pin = context.getInputValue(block, 'PIN') || context.getFieldValue(block, 'PIN');
        let state = context.getInputValue(block, 'STATE') || context.getFieldValue(block, 'STATE');
        
        pin = stripQuotes(pin);
        state = stripQuotes(state);
        
        return `while (digitalRead(${pin}) != ${state}) { delay(10); }`;
    });

    BlockRegistry.register('genericDevice_serialBegin', (block, context) => {
        const baud = context.getInputValue(block, 'BAUD') || context.getFieldValue(block, 'BAUD') || '9600';
        context.addSetup(`Serial.begin(${baud});`);
        return '';
    });

    BlockRegistry.register('genericDevice_serialPrint', (block, context) => {
        const text = context.getInputValue(block, 'TEXT');
        return `Serial.print(${text})`;
    });

    BlockRegistry.register('genericDevice_serialPrintln', (block, context) => {
        const text = context.getInputValue(block, 'TEXT');
        return `Serial.println(${text})`;
    });

    BlockRegistry.register('genericDevice_serialAvailable', (block, context) => {
        return `(Serial.available() > 0)`;
    });

    BlockRegistry.register('genericDevice_serialRead', (block, context) => {
        return `Serial.readString()`;
    });

    BlockRegistry.register('genericDevice_serialLastLine', (block, context) => {
        return `Serial.readStringUntil('\\n')`;
    });
}
